/**
 * eSalon Before/After Slider (DEV-4285)
 *
 * Mirrors the range input's value onto the --esalon-before-after-pos custom
 * property. That is the whole job: the clip-path, divider and pill all read from
 * that property in CSS, so drag, touch and keyboard are handled by the native
 * input and nothing here needs pointer maths.
 *
 * Progressive enhancement: with this script absent the input still works and the
 * images still render, they just sit at the 50% default.
 */

function initBeforeAfter(frame) {
  if (frame.dataset.beforeAfterReady === 'true') return;
  frame.dataset.beforeAfterReady = 'true';

  const range = frame.querySelector('[data-before-after-range]');
  if (!range) return;

  // The property lives on the outer wrapper so the labels could read it too.
  const scope = frame.closest('.esalon-before-after') || frame;

  const apply = () => {
    scope.style.setProperty('--esalon-before-after-pos', `${range.value}%`);
  };

  range.addEventListener('input', apply);
  apply();
}

function initAll(root = document) {
  root.querySelectorAll('[data-before-after]').forEach(initBeforeAfter);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAll());
} else {
  initAll();
}

// Re-run when a section is re-rendered in the theme editor.
document.addEventListener('shopify:section:load', (event) => initAll(event.target));
